// extracted by mini-css-extract-plugin
export default {"select":"Quotes_select__pLI+Q","container":"Quotes_container__Ic0Oe"};